import { Component, Input, signal } from '@angular/core';
import { Observable, SubscriptionLike } from 'rxjs';
import { ReviewKPIs } from 'src/modals/planogram';
import { PlanogramStateService } from 'src/services/planogram-state.service';

@Component({
  selector: 'app-side-accordian',
  templateUrl: './side-accordian.component.html',
  styleUrl: './side-accordian.component.css',
})
export class SideAccordianComponent {
  readonly channelPanelOpenState = signal(true);
  readonly estimatedPanelOpenState = signal(true);
  readonly categoryMixPanelOpenState = signal(true);
  readonly brandMixPanelOpenState = signal(true);
  readonly packMixPanelOpenState = signal(true);
  packOrderDescription = signal<any>('');
  packOrder = signal<any>([]);
  numberOfShelvesAndFacing = signal<any>({});
  @Input() planogram_id: number;
  @Input() planogram_details: any;
  @Input() reset: boolean;

  review_kpis: ReviewKPIs = {};
  review_kpis_subscription: SubscriptionLike;
  review_kpis_observable: Observable<ReviewKPIs> =
    this.planogramState.review_kpis;
  columnNames: string[];
  numberOfColumns: number;
  // planogramId: number=3547;
  // this.review_kpis['numberOfShelvesAndFacing']

  constructor(private planogramState: PlanogramStateService) {}
  ngOnInit(): void {
    console.log('this.planogram_id', this.planogram_id);
    if (this.planogram_id) {
      setTimeout(() => {
        this.planogramState.getReviewKpis({ id: this.planogram_id });
      }, 2500);
    }
    this.review_kpis_subscription = this.review_kpis_observable.subscribe(
      (res) => {
        if (res && Object.values(res).length>0) {
          this.review_kpis = res;

          this.packOrder.set(res['pack_order']);
          this.numberOfShelvesAndFacing.set(
            this.transformInputForNumberOfShelvesAndFacing(
              res['numbers_of_shelves_and_facings']
            )
          );
          const placementInfo: any = res['placement_info'];
          this.packOrderDescription.set(placementInfo.description);
          // console.log("review_kpis_subscription",res)
        }
      }
    );
  }

  transformInputForNumberOfShelvesAndFacing(value: any) {
    if (value) {
      this.columnNames = Object.keys(value);
      this.numberOfColumns = this.columnNames.length + 1;
      return value;
    }
  }

  populateRepresentation(value: string) {
    if (
      this.review_kpis &&
      Object.keys(this.review_kpis).length > 0 &&
      this.review_kpis[value]
    ) {
      let data = this.review_kpis[value];
      return Object.keys(data);
    } else return [];
  }
  getChannelOutput(value: any, type: string) {
    // console.log("getChannelOutput",value)
    if (type == 'shelf_configs') {
      let str = '';
      for (const [key, val] of Object.entries(value[type])) {
        // console.log(`${key}: ${value}`);
        str = str + `${key}-${val} \n`;
      }
      return str;
    } else {
      return value[type];
    }
  }
  spaceFilledProgressBarValue(key: string) {
    let value = (
      this.review_kpis['space_filled'] as {
        [key: string]: number | { [key: string]: number };
      }
    )[key];
    let coverage = (value as { [key: string]: number })['coverage'];
    let total = (value as { [key: string]: number })['total'];
    let calculateValue = (coverage / total) * 100;
    return { calculateValue: calculateValue, coverage: coverage, total: total };
  }

  valueOfRepresntation(val: string, type: string) {
    const nestedValue = (
      this.review_kpis[type] as {
        [key: string]: number | { [key: string]: number };
      }
    )[val];
    return nestedValue;
  }

  ngOnDestroy(): void {
    this.review_kpis_subscription.unsubscribe();
  }
}
